import { GroupSecurity } from '@quromedical/fhir-common';
import { PatientHeaderSection } from 'core/patient';
import { Alert, Snackbar, Tabs } from 'design-system';
import { useUserSession } from 'hooks';
import { usePathologyActions } from 'hooks/usePathology';
import { PathologyStackScreenProps } from 'navigation';
import { usePatientId } from 'providers/PatientIdContext';
import React, { useEffect, useState } from 'react';
import { ScrollView } from 'react-native';
import { NotFoundScreen } from 'screens/NotFoundScreen';
import { strings } from 'strings';

import { ReportTab, RequestTab } from './tabs';

export const PathologyScreen: React.FC<PathologyStackScreenProps<'List'>> = () => {
  const id = usePatientId();
  const session = useUserSession();
  const pathologyActions = usePathologyActions();

  const { error } = pathologyActions;

  const [snackState, setSnackState] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      setSnackState(true);
    }
  }, [error]);

  if (!id) {
    return <NotFoundScreen />;
  }

  const hasPathologyRead = session.hasAny([GroupSecurity.ServiceRequestRead]);
  const hasPathologyWrite = session.hasAny([GroupSecurity.DiagnosticReportRead]);
  return (
    <ScrollView>
      <Snackbar
        isOpen={snackState}
        onClose={() => {
          return;
        }}
      >
        <Alert
          actionIcon="close"
          backgroundColor="status-critical"
          onAction={() => {
            setSnackState(false);
          }}
          title={strings.AlertError}
          body={error}
          icon="error"
        />
      </Snackbar>
      <PatientHeaderSection id={id} />
      <Tabs.Group>
        <Tabs.Screen isHidden={!hasPathologyRead} title={strings.PathologyRequestsTabTitle}>
          <RequestTab usePathologyProps={pathologyActions} patientId={id} />
        </Tabs.Screen>
        <Tabs.Screen isHidden={!hasPathologyWrite} title={strings.PathologyReportsTabTitle}>
          <ReportTab patientId={id} />
        </Tabs.Screen>
      </Tabs.Group>
    </ScrollView>
  );
};
